import ActionsForm from '@/shared/mixins/actionsForm'
// import { loading, toast } from '@/shared/utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'
export default {
  name: 'collapseEditApr',
  mixins: [ActionsForm, PermissionMixin],
  components: {},
  data () {
    return {
      internalForm: {}
    }
  },

  mounted () {
    this.internalForm = {...this.form}
  },

  props: {
    form: {
      type: Object,
      requered: false
    },
    categoriaNomeEdit: {
      type: String,
      default: null
    }
  },

  watch: {
  },

  methods: {
    cancel () {
      this.fechaPopAtualizaGrid = !this.fechaPopAtualizaGrid
      this.$emit('fechaPopAtualizaGrid', this.fechaPopAtualizaGrid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/registerApr/components/collapseapr/components/collapseEditApr/collapseEditApr.js